module.exports = __webpack_public_path__ + "static/media/image6.317f89b8.jpg";